type Props = { className?: string };

export default function DoricColumn({ className = '' }: Props) {
  return (
    <svg
      className={className}
      width="24"
      height="100%"
      viewBox="0 0 24 600"
      preserveAspectRatio="none"
      fill="#2B2414"
      style={{ opacity: 0.1 }}
      aria-hidden
    >
      <rect x="0" y="0" width="24" height="4" />
      <rect x="2" y="4" width="20" height="4" />

      <rect x="6" y="8" width="12" height="584" />

      <rect x="2" y="592" width="20" height="4" />
      <rect x="0" y="596" width="24" height="4" />
    </svg>
  );
}
